import { Component, ElementRef, Injector, OnInit } from '@angular/core';
import { ApComplexModal, ModalHelperService } from '../modals/index';

@Component({
  selector: 'ap-confirm-modal',
  styleUrls: ['ap-confirm-modal.component.less'],
  templateUrl: './ap-confirm-modal.component.html',
})
export class ApConfirmModalComponent extends ApComplexModal<boolean> implements OnInit {
  baseId: string;
  bodyText: string;
  Id: string;
  modalTitleText: string;
  noButtonText: string;
  yesButtonText: string;
  hideHeader: boolean | null;
  hideNoButton: boolean | null;

  private readonly element: Element;

  constructor(
    elementInjector: Injector,
    private readonly elementRef: ElementRef<HTMLElement>,
    private readonly modalHelperService: ModalHelperService,
  ) {
    super(elementInjector);

    this.element = this.elementRef.nativeElement;
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.modalHelperService.appendModalOverrideClass(this.element);
    this.setId();
  }

  yesSelected() {
    this.apClose(true);
  }

  noSelected() {
    this.apClose(false);
  }

  setId() {
    this.Id = `${this.baseId}-confirm-modal`;
  }
}
